import {React} from 'common'
import {useI18n} from 'store/Store'
import {validationPatterns} from 'constants/auth'
import Link from '@mui/material/Link'
import {
    FormActionButton,
    FormRow,
    FormAdditionalButton,
    FormAdditionalText,
    FormErrorMessage,
} from 'components/Control/Form'
import {useNavigate} from 'react-router-dom'
import FormTextInput from 'components/Control/Form/FormTextInput'
import {FormLabel, styled} from '@mui/material'
import analyticsService from 'services/analytic'
import {Colors} from 'appearance'

const LoginDetailsSection = ({
    login,
    control,
    errors,
    isLoadingVerifySms,
    isLoadingLogin,
    loginErrorMessage,
}) => {
    const navigate = useNavigate()
    const {i18n} = useI18n()

    return (
        <Container>
            <FormTextInput
                fullWidth
                name="username"
                control={control}
                rules={{
                    required: true,
                }}
                errors={errors}
                LabelComponent={() => <Label>{i18n.t('users.username')}</Label>}
                placeholder={i18n.t('users.usernamePlaceholder')}
                height="50px"
                style={{marginBlock: 12}}
            />

            <FormTextInput
                fullWidth
                name="password"
                control={control}
                rules={{
                    required: true,
                    validationPatterns: validationPatterns.NUMBER,
                }}
                errors={errors}
                type="password"
                LabelComponent={() => <Label>{i18n.t('users.password')}</Label>}
                height="50px"
                style={{marginBlock: 12}}
            />

            <PaddedFormRow>
                <Link
                    // color="secondary"
                    href={'/forgotPassword'}
                    onClick={() => {
                        analyticsService.loginPageForgotPassword()
                    }}
                    style={{whiteSpace: 'nowrap', color: Colors.LINK_TEXT}}>
                    {i18n.t('users.forgotPassword')}
                </Link>
            </PaddedFormRow>

            <FormActionButton
                loading={isLoadingLogin || isLoadingVerifySms}
                color="secondary"
                onClick={login}
                variant="contained"
                height={50}>
                {i18n.t('users.signin')}
            </FormActionButton>

            <FormErrorMessage errorMessage={loginErrorMessage} />
            <RegisterLink>
                <FormAdditionalText>
                    {i18n.t('users.newUser')}
                </FormAdditionalText>
                <FormAdditionalButton
                    style={{color: Colors.LINK_TEXT, fontSize: 18}}
                    onClick={() => {
                        navigate('/register')
                        analyticsService.loginPagePressedCreateAccount()
                    }}>
                    {i18n.t('users.register')}
                </FormAdditionalButton>
            </RegisterLink>
        </Container>
    )
}

export default LoginDetailsSection

const Container = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
`

const Label = styled(FormLabel)`
    font-weight: bold;
    font-size: 16px;
    color: rgba(149, 150, 154, 1);
`

const RegisterLink = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    & > * {
        font-size: 18px;
        font-weight: 400;
    }
`

const PaddedFormRow = styled(FormRow)`
    padding: 20px 0px;
`
